import { render, staticRenderFns } from "./MiddleHome.vue?vue&type=template&id=36a8cbec&scoped=true&"
import script from "./MiddleHome.vue?vue&type=script&lang=js&"
export * from "./MiddleHome.vue?vue&type=script&lang=js&"
import style0 from "./MiddleHome.vue?vue&type=style&index=0&id=36a8cbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8cbec",
  null
  
)

export default component.exports